import Axios from 'axios'
import Auth from './auth'
import {API_KEY, API} from './constants'

export default {
	verify(request) {
		request.code = btoa(btoa(request.code));
		return Axios.post(API.VERIFY, request,  authorizeKey());
	},
	register(user) {
		return Axios.post(API.REGISTER, user);
	},

	address: {
		getRegions() {
			return Axios.get(API.ADDRESS + '/regions');
		},
		getProvinces(regionCode) {
			return Axios.get(API.ADDRESS + '/provinces/' + regionCode);
		},
		getCities(provinceCode) {
			return Axios.get(API.ADDRESS + '/cities/' + provinceCode);
		},
		getBarangays(cityCode) {
			return Axios.get(API.ADDRESS + '/barangays/' + cityCode);
		},
		getDistricts() {
			return new Promise((resolve) => {
					resolve([
						{ "text": "N/A", value: null },
						{ "text": "District I", value: "District I" },
						{ "text": "District II", value: "District II" },
						{ "text": "District III", value: "District III" },
						{ "text": "District IV", value: "District IV" },
						{ "text": "District V", value: "District V" },
						{ "text": "District VI", value: "District VI" },
						{ "text": "District VII", value: "District VII" },
						{ "text": "District VIII", value: "District VIII" },
						{ "text": "District IX", value: "District IX" },
						{ "text": "District X", value: "District X" }
					]);
				});
		}
	},

	course: {
		get(id) {
			return Axios.get(API.COURSE + '/' + id, authorize());
		},
		getAll() {
			return Axios.get(API.COURSE);
		},
		getAllFromType(courseTypeId) {
			return Axios.get(API.COURSE + '/type/' + courseTypeId);
		},
		getAllTypes() {
			return Axios.get(API.COURSE + '/type');
		},		
		getGroups(courseId) {
			return Axios.get(API.COURSE + '/' + courseId + '/group');
		},
		create(user) {
			return Axios.post(API.COURSE + '/create', user, authorize());
		},
		update(course) {
			return Axios.post(API.COURSE + '/update', course, authorize());
		},
		updateHidden(course) {
			return Axios.post(API.COURSE + '/update/hidden', course, authorize());
		},
		updateAvailable(course) {
			return Axios.post(API.COURSE + '/update/available', course, authorize());
		},
		delete(id) {
			return Axios.post(API.COURSE + '/delete', { id }, authorize());
		},
		group: {
			get(id) {
				return Axios.get(API.COURSE + '/group/' + id, authorize());
			},
			create(courseGroup) {
				return Axios.post(API.COURSE + '/group/create', courseGroup, authorize());
			},		
			update(courseGroup) {
				return Axios.post(API.COURSE + '/group/update', courseGroup, authorize());
			},
			delete(id) {
				return Axios.post(API.COURSE + '/group/delete', { id }, authorize());
			},
		},
	},

	exam: {
		get(hashId) {
			return Axios.get(API.EXAM + '/' + hashId, authorizeKey());
		},
		getAll(startDate, endDate, courseId, registrationStatus) {
			let queryObj = authorize();
			queryObj.params = {
				startDate,
				endDate,
				courseId,
				registrationStatus,
			};
			return Axios.get(API.EXAM, queryObj);
		},
		delete(id) {
			return Axios.post(API.EXAM + '/delete', { id }, authorize());
		},
		getTimeLimit(hashId) {
			return Axios.get(API.EXAM + '/timeLimit/' + hashId, authorizeKey());
		},
		startExam(hashId) {
			return Axios.post(API.EXAM + '/startExam', { hashId }, authorizeKey());
		},
		userAnswer(examHashId) {
			return Axios.get(API.EXAM + '/userAnswer/' + examHashId, authorizeKey());
		},
		saveAnswer(examAnswer) {
			return Axios.post(API.EXAM + '/saveAnswer', examAnswer, authorizeKey());
		},
		submitAnswers(examHashId) {
			return Axios.post(API.EXAM + '/submitAnswers', { examHashId }, authorizeKey());
		},
	},
	
	registration: {
		get(id) {
			return Axios.get(API.REGISTRATION + '/' + id, authorize());
		},
		getAll(startDate, endDate, courseTypeId, courseGroupId, courseId, status) {
			let queryObj = authorize();
			queryObj.params = {
				startDate,
				endDate,
				courseTypeId,
				courseGroupId,
				courseId,
				status,
			};
			return Axios.get(API.REGISTRATION, queryObj);
		},
		getAllFromCourseType(courseTypeId) { // unused
			return Axios.get(API.REGISTRATION + '/courseType/' + courseTypeId, authorize());
		},
		searchEnrolled(firstname, lastname) {
			let queryObj = authorize();
			queryObj.params = { firstname, lastname };
			return Axios.get(API.REGISTRATION + '/searchEnrolled', queryObj, authorize());
		},
		update(registration) {
			return Axios.post(API.REGISTRATION + '/update', registration, authorize());
		},
		delete(id) {
			return Axios.post(API.REGISTRATION + '/delete', { id }, authorize());
		},
		approve(id, approverId) {
			return Axios.post(API.REGISTRATION + '/approve', { id, approverId }, authorize());
		},
		reject(id, rejecterId, remarks) {
			return Axios.post(API.REGISTRATION + '/reject', { id, rejecterId, remarks }, authorize());
		},
		enroll(id, enrollerId) {
			return Axios.post(API.REGISTRATION + '/enroll', { id, enrollerId }, authorize());
		},
		restore(registration) {
			return Axios.post(API.REGISTRATION + '/restore', registration, authorize());
		},
		cancel(id, rejecterId) {
			return Axios.post(API.REGISTRATION + '/cancel', { id, rejecterId }, authorize());
		},
		transfer(id, courseId) {
			return Axios.post(API.REGISTRATION + '/transfer', { id, courseId }, authorize());
		},
		bulkGroupTransfer(courseGroupId, registrations) {
			return Axios.post(API.REGISTRATION + '/bulkGroupTransfer', { courseGroupId, registrations }, authorize());
		},
	},
	
	question: {
		// get(id) {
		//     return Axios.get(API.REGISTRATION + '/' + id, authorizeKey());
		// },
		getFromSet(questionSetId) {
			return Axios.get(API.QUESTION + '/set/' + questionSetId, authorizeKey());
		},
	},
	
	user: {
		get(id) {
			return Axios.get(API.USER + '/' + id, authorize());
		},
		getSelf(id) {
			return Axios.get(API.USER + '/self/' + id, authorize());
		},
		getAll() {
			return Axios.get(API.USER, authorize());
		},
		getAllNames() {
			return Axios.get(API.USER + '/getAllNames', authorize());
		},
		create(user) {
			return Axios.post(API.USER + '/create', user, authorize());
		},
		update(user) {
			return Axios.post(API.USER + '/update', user, authorize());
		},
		updateSelf(user) {
			return Axios.post(API.USER + '/update/self', user, authorize());
		},
		delete(id) {
			return Axios.post(API.USER + '/delete', { id: id }, authorize());
		},
		check(user) {
			return Axios.post(API.USER + '/check', user);
		},
		getCourses(userId) {
			return Axios.get(API.USER + '/' + userId + '/courses', authorize());
		},
		getTopics(userId) {
			return Axios.get(API.USER + '/' + userId + '/topics', authorize());
		},
		getQuizzes(userId) {
			return Axios.get(API.USER + '/' + userId + '/quizzes', authorize());
		},
	},

	sms: {
		send(mobile, message) {
			return Axios.post(API.SMS + '/send', { mobile, message }, authorize());
		},
		credits() {
			return Axios.get(API.SMS + '/credits', authorize());
		}
	}
}

function authorize() {
	return {
		headers: { 
			Authorization: Auth.getToken() 
		}
	}
}

function authorizeKey() {
	return {
		headers: { 
			Authorization: API_KEY 
		}
	}
}